import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCountValue, fetchDaycareRevenue, fetchRecentDaycare, fetchMostUsedSubscription, fetchRecentDaycareTransaction, fetchPerformanceDaycare, fetchActionCenter } from "../../service/api";

export const getCountData = createAsyncThunk(
    "dashboard/getCount",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchCountValue(params)
            console.log("analytics response", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const getDaycareRevenue = createAsyncThunk(
    "dashboard/getRevenue",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDaycareRevenue(params)
            console.log("revenue response", response)
            return response.data.data.revenueOverview
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const getRecentDaycare = createAsyncThunk(
    "dashboard/getRecentDaycare",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchRecentDaycare(params)
            return response.data.data.recentDaycares
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const getMostUsedSubscription = createAsyncThunk(
    "dashboard/getMostUsedSubscription",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchMostUsedSubscription(params)
            return response.data.data.subscriptions
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const getRecentTransaction = createAsyncThunk(
    "dashboard/getTrans",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchRecentDaycareTransaction(params)
            return response.data.data.transactions
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const getActionCenter = createAsyncThunk(
    "dashboard/getActions",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchActionCenter(params)
            console.log("response actions", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)


export const getTopPerformingDaycare = createAsyncThunk(
    "dashboard/getTopPerforming",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchPerformanceDaycare(params)
            return response.data.data.topDaycares
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)


const dashboardSlice = createSlice({
    name: "dashboards",
    initialState: {
        countData: {},
        countStatus: {},
        revenueData: [],
        recentDaycare: [],
        actionCenter: [],
        mostUsedSubscription: [],
        recentTransaction: [],
        topPerformingDaycare: [],
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        const handle = (thunk, key) => {
            builder
                .addCase(thunk.pending, (state) => { state.isLoading = true })
                .addCase(thunk.fulfilled, (state, action) => {
                    state.isLoading = false
                    state[key] = action.payload ?? action.payload
                })
                .addCase(thunk.rejected, (state) => { state.isLoading = false })
        }
        // Custom handler for count API
        builder
            .addCase(getActionCenter.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getActionCenter.fulfilled, (state, action) => {
                state.isLoading = false;
                state.actionCenter = action.payload.data || {};
                state.countStatus = action.payload.countStatus || {};
            })
            .addCase(getActionCenter.rejected, (state) => {
                state.isLoading = false;
            })
        handle(getCountData, 'countData')
        handle(getDaycareRevenue, 'revenueData')
        handle(getRecentDaycare, 'recentDaycare')
        handle(getMostUsedSubscription, 'mostUsedSubscription')
        handle(getRecentTransaction, 'recentTransaction')
        handle(getTopPerformingDaycare, 'topPerformingDaycare')
    }
})

export default dashboardSlice.reducer